import { useRef } from "react";
import { useUserContext } from "../../context/userContext";
import { Link } from "react-router-dom";

import { useContext } from "react";
import { DarkModeContext } from "../DarkModeProvider"


const SignIn = ({ toggleIndex, index}) => {
    const emailRef = useRef()
    const psdRef = useRef()

    const { signInUser, error } = useUserContext();
    

    const onSubmit = (e) => {
        e.preventDefault();
        const email = emailRef.current.value;
        const password = psdRef.current.value;

        if (email && password) signInUser(email, password)
    }


    const { darkMode } = useContext(DarkModeContext);

    return (
        <>
        <section className={darkMode ? 'auth dark' : 'auth light'}>
        <div className="container">
          <div className="auth__container">
            <h2 className={darkMode ? 'dark-text' : 'light-text'}>Přihlásit se</h2>
            <form className="auth__content" onSubmit={onSubmit}>
              <div className="auth__content--input">
                <label className={darkMode ? 'dark-second-text' : 'light-second-text'} htmlFor="email">Email</label>
                <input type="email" ref={emailRef} />
              </div>
              <div className="auth__content--input">
                <label className={darkMode ? 'dark-second-text' : 'light-second-text'} htmlFor="password">Heslo</label>
                <input type="Password" ref={psdRef} />
              </div>

              <button className={darkMode ? 'auth__content--button dark-button-text' : 'auth__content--button'} type="submit">
                <span>
                    Pokračovat
                </span>
              </button>
            </form>

            <div className="forget__password--error">
              <Link to="/profile/forgetpassword" className={darkMode ? 'forget__password dark-text' : 'forget__password light-text'}>Zapomenuté heslo?</Link>
              {error && <p className='error'>{error}</p>}
            </div>

            <p className={darkMode ? 'auth__login dark-text' : 'auth__login light-text'} onClick={toggleIndex}>
                Nemáte účet? <strong>Zaregistrujte se</strong>
            </p>
          </div>
        </div>
      </section>
            {/* <div className="auth">
                <h2>Login</h2>

                <form onSubmit={onSubmit}>
                    <button type="submit">Sign In</button>
                    <p onClick={forgotPasswordHandler}>Forgot Password?</p>
                </form>
                <p onClick={toggleIndex}>
                    {!index ? "Nemáte účet? Zaregistrujte se" : "Máte již účet? Přihlaste se"}
                </p>
            </div> */}
        </>
    )
}

export default SignIn;